/* ============================================================================
   Hendy — winkelwagen v3.1 · assets/hendy-cart.js
   Werkt NAAST Dawn's assets/cart.js (aantal, verwijderen) en assets/cart-drawer.js (openen, sluiten, re-render).
   Doet zelf: cadeau kiezen · upsell toevoegen · betaald cadeau opruimen · kortingscode · express-knoppen herladen ·
   hoesje-upsell koppelen aan het gekozen toestel (localStorage hendy_device_v1 = { title, url }, uit hendy-device.js).
   Geen eigen cart-status: na elke wijziging rendert Shopify de drawer opnieuw uit Liquid.
   ========================================================================== */
(function () {
  'use strict';
  if (window.HendyCart) { return; }                       // niet dubbel laden

  var R = window.routes || {};
  var ADD = R.cart_add_url || '/cart/add.js';
  var CHANGE = R.cart_change_url || '/cart/change.js';
  var CART = R.cart_url || '/cart';
  var ROOT = (R.root_url || '/').replace(/\/$/, '');
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var DEVICE_KEY = 'hendy_device_v1';

  function q(sel, root) { return (root || document).querySelector(sel); }
  function drawerEl() { return q('cart-drawer'); }
  function store(key, val) { try { if (val === null) { sessionStorage.removeItem(key); } else { sessionStorage.setItem(key, val); } } catch (e) {} }
  function read(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }
  function emit(action, detail) {
    /* Haak voor GA4 / custom pixel: document.addEventListener('hendy:cart', e => e.detail) */
    try { document.dispatchEvent(new CustomEvent('hendy:cart', { detail: Object.assign({ action: action }, detail || {}) })); } catch (e) {}
  }

  function showError(msg) {
    var box = q('#CartDrawer-CartErrors') || q('#cart-errors');
    var text = msg || 'Er ging iets mis. Probeer het opnieuw.';
    if (box) { box.textContent = text; } else { window.alert(text); }
  }

  /* ---- re-render: bij voorkeur via Dawn (houdt de drawer open en herstelt de overlay-klik) ---- */
  function rerender(parsed) {
    var d = drawerEl();
    if (d && typeof d.renderContents === 'function') { d.renderContents(parsed); return; }
    var sec = parsed.sections || {};
    if (sec['cart-drawer'] && q('#CartDrawer')) {
      var src = new DOMParser().parseFromString(sec['cart-drawer'], 'text/html').querySelector('#CartDrawer');
      if (src) { q('#CartDrawer').innerHTML = src.innerHTML; }
    }
    if (sec['cart-icon-bubble'] && q('#cart-icon-bubble')) {
      var bub = new DOMParser().parseFromString(sec['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (bub) { q('#cart-icon-bubble').innerHTML = bub.innerHTML; }
    }
    if (d && typeof d.open === 'function') { d.open(); }
  }
  function publishUpdate(parsed) {
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'hendy-cart', cartData: parsed });
    }
  }
  function afterChange(parsed) {
    if (drawerEl()) { rerender(parsed); } else { window.location.href = CART; }   // cart-pagina: herladen volstaat
    publishUpdate(parsed);
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok || json.status) { throw new Error(json.description || json.message || 'Kon de winkelwagen niet bijwerken.'); }
        return json;
      });
    });
  }

  function addVariant(id, properties, btn, action) {
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    var item = { id: Number(id), quantity: 1 };
    if (properties) { item.properties = properties; }
    return post(ADD, { items: [item], sections: SECTIONS, sections_url: window.location.pathname })
      .then(function (parsed) { emit(action, { variant_id: Number(id) }); afterChange(parsed); })
      .catch(function (err) {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
        showError(err.message);
      });
  }
  function changeLine(line, quantity) {
    return post(CHANGE, { line: Number(line), quantity: quantity, sections: SECTIONS, sections_url: window.location.pathname })
      .then(afterChange)
      .catch(function (err) { showError(err.message); });
  }

  /* ---- betaald cadeau opruimen: de korting geldt niet meer (bv. een product verwijderd) ----------
     De regel draagt property _hendy_gift maar staat niet op €0 → weg ermee, de balk legt uit wat er nodig is.
     Beveiliging: na twee keer in één sessie stoppen we (dan is de automatische korting niet goed ingesteld). */
  function cleanPaidGift() {
    var paid = q('[data-hendy-gift-paid]');
    if (!paid) { return false; }
    var n = Number(read('hendy_gift_removed') || 0);
    if (n >= 2) { return false; }
    store('hendy_gift_removed', String(n + 1));
    emit('gift_removed', { line: paid.getAttribute('data-hendy-line') });
    changeLine(paid.getAttribute('data-hendy-line'), 0);
    return true;
  }

  /* ---- hoesje-upsell: koppel het gekozen toestel aan de juiste modelvariant ---------------------- */
  function readDevice() {
    var raw = null;
    try { raw = window.localStorage.getItem(DEVICE_KEY); } catch (e) { return null; }
    if (!raw) { return null; }
    try {
      var j = JSON.parse(raw);
      if (j && typeof j === 'object') { return j.title || j.model || j.name || j.device || j.value || null; }   /* hendy-device.js schrijft { title, url } */
      return typeof j === 'string' ? j : null;
    } catch (e) { return raw; }
  }
  function resolveUpsellModel() {
    var box = q('[data-hendy-upsell-needs-model]');
    if (!box || box.getAttribute('data-hendy-resolved')) { return; }
    box.setAttribute('data-hendy-resolved', '1');
    var device = readDevice();
    if (!device) { return; }
    var variants = [];
    try { variants = JSON.parse(q('[data-hendy-upsell-variants]', box).textContent); } catch (e) { return; }
    var dev = String(device).trim().toLowerCase();
    var match = variants.filter(function (v) { return v.available && String(v.model || '').trim().toLowerCase() === dev; })[0];
    if (!match) { return; }
    var link = q('[data-hendy-upsell-btn]', box);
    if (!link) { return; }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = link.className;
    btn.textContent = 'Toevoegen';
    btn.setAttribute('data-hendy-upsell-variant', match.id);
    link.replaceWith(btn);
  }

  /* ---- kortingscode: cookie via /discount/CODE, dan de wagen zelf laten bijwerken -----------------
     /discount/CODE accepteert en redirect ALTIJD, ook bij een niet-bestaande of verlopen code — het
     bevestigt niets. Daarom na afloop de wagen opnieuw ophalen en zelf controleren of de code in
     cart.discount_codes.applicable op true staat. Is de code geldig, dan ook meteen de hele wagen
     opnieuw laten renderen (zelfde pad als na een aantal-wijziging) zodat het totaal HIER al klopt,
     i.p.v. alleen een belofte "wordt bij het afrekenen verrekend" te tonen. */
  function refreshCartDisplay() {
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(SECTIONS), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (sections) { rerender({ sections: sections }); publishUpdate({ sections: sections }); });
  }
  function applyDiscount(form) {
    var input = q('input', form);
    var code = (input.value || '').trim();
    if (!code) { input.focus(); return; }
    var msg = q('[data-hendy-disc-msg]', form.parentNode);
    var btn = q('button[type="submit"]', form);
    if (btn) { btn.classList.add('is-loading'); }
    fetch(ROOT + '/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () { return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var entered = (cart.discount_codes || []).filter(function (d) {
          return (d.code || '').toLowerCase() === code.toLowerCase();
        }).pop();
        var ok = !!(entered && entered.applicable);
        emit('discount_entered', { code: code, applicable: ok });
        if (ok) {
          return refreshCartDisplay().then(function () {
            var freshMsg = q('[data-hendy-disc-msg]');
            if (freshMsg) { freshMsg.textContent = 'Code toegepast.'; freshMsg.classList.remove('is-error'); freshMsg.hidden = false; }
          });
        }
        if (msg) { msg.textContent = 'Deze code is niet geldig of niet meer geldig.'; msg.classList.add('is-error'); msg.hidden = false; }
      })
      .catch(function () {
        if (msg) { msg.textContent = 'De code kon niet worden gecontroleerd. Probeer het opnieuw.'; msg.classList.add('is-error'); msg.hidden = false; }
      })
      .then(function () {
        if (btn) { btn.classList.remove('is-loading'); }
        var freshBtn = q('.hy-disc__form button[type="submit"]');
        if (freshBtn) { freshBtn.classList.remove('is-loading'); }
      });
  }
  function toggleDisc(btn) {
    var box = btn.closest('[data-hendy-disc]');
    if (!box) { return; }
    var open = box.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    store('hendy_disc_open', open ? '1' : '0');
    if (open) { var i = q('input', box); if (i) { i.focus(); } }
  }
  function restoreDisc() {
    if (read('hendy_disc_open') !== '1') { return; }
    var box = q('[data-hendy-disc]');
    if (box && !box.classList.contains('is-open')) {
      box.classList.add('is-open');
      var t = q('[data-hendy-disc-toggle]', box);
      if (t) { t.setAttribute('aria-expanded', 'true'); }
    }
  }

  /* ---- express-knoppen (Shop Pay / Apple Pay) na een re-render opnieuw laten tekenen -------------- */
  function reinitWallets() {
    var box = q('.hy-foot__express');
    if (!box || box.getAttribute('data-hendy-wallets')) { return; }
    box.setAttribute('data-hendy-wallets', '1');
    if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
      try { window.Shopify.PaymentButton.init(); } catch (e) {}
    }
  }

  function hydrate() {
    if (cleanPaidGift()) { return; }     // er volgt een re-render, daarna komen we hier terug
    resolveUpsellModel();
    restoreDisc();
    reinitWallets();
  }

  /* ---- events ------------------------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-hendy-gift-variant],[data-hendy-upsell-variant],[data-hendy-disc-toggle]');
    if (!el) { return; }
    if (el.hasAttribute('data-hendy-gift-variant')) {
      e.preventDefault();
      store('hendy_gift_removed', null);
      addVariant(el.getAttribute('data-hendy-gift-variant'), { _hendy_gift: '1' }, el, 'gift_pick');
      return;
    }
    if (el.hasAttribute('data-hendy-upsell-variant')) {
      e.preventDefault();
      addVariant(el.getAttribute('data-hendy-upsell-variant'), null, el, 'upsell_add');
      return;
    }
    e.preventDefault();
    toggleDisc(el);
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-hendy-disc-form]');
    if (!f) { return; }
    e.preventDefault();
    applyDiscount(f);
  });

  /* ---- na elke re-render van drawer of cart-pagina opnieuw hydrateren ----------------------------- */
  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(hydrate, 60); }
  function observe(target) { if (target) { new MutationObserver(schedule).observe(target, { childList: true, subtree: true }); } }
  function init() {
    observe(q('#CartDrawer'));
    observe(q('#main-cart-items'));
    hydrate();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

  window.HendyCart = { add: addVariant, change: changeLine, hydrate: hydrate };
})();
